import { Box, CircularProgress, Stack, Typography } from '@mui/material';

import { translate } from '@/ui/i18n';

export function LoadingView({
  text = translate('Common.Loading'),
}: {
  text?: string;
}) {
  return (
    <Box>
      <Stack direction={'row'} spacing={2} alignItems={'center'}>
        <CircularProgress size={20} />
        <Typography>{text}</Typography>
      </Stack>
    </Box>
  );
}
